import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Card } from 'primeng/card';

@Component({
  selector: 'app-generic-outage',
  imports: [CommonModule, RouterModule, Card, NgOptimizedImage],
  templateUrl: './generic-outage.ui-component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericOutageUiComponent {}
